export default function isPartiallyInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    // Check if element's bottom is visible (above the bottom of viewport)
    rect.bottom > 0 &&
    rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
    // Check if element's right side is visible (left of viewport edge)
    rect.right > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth)
  );
}
